export const auth = {
  user: {},
  userLoaded: false,
};
